var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoicesvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 6H40V36.984C40 41.0968 35.311 43.4507 32.0128 40.9936L30.6034 39.9436C30.248 39.6788 29.7606 39.6795 29.406 39.9455L28.8 40.4C25.9556 42.5333 22.0444 42.5333 19.2 40.4L18.594 39.9455C18.2394 39.6795 17.752 39.6788 17.3966 39.9436L15.9872 40.9936C12.689 43.4507 8 41.0968 8 36.984V6ZM12 10V36.984C12 37.8065 12.9378 38.2773 13.5974 37.7859L15.0068 36.7359C16.7841 35.4118 19.221 35.4157 20.994 36.7455L21.6 37.2C23.0222 38.2667 24.9778 38.2667 26.4 37.2L27.006 36.7455C28.779 35.4157 31.2159 35.4118 32.9932 36.7359L34.4026 37.7859C35.0622 38.2773 36 37.8065 36 36.984V10H12Z",
    fill: "#6B92FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 16C16.8954 16 16 16.8954 16 18C16 19.1046 16.8954 20 18 20H22C23.1046 20 24 19.1046 24 18C24 16.8954 23.1046 16 22 16H18ZM30 16C28.8954 16 28 16.8954 28 18C28 19.1046 28.8954 20 30 20C31.1046 20 32 19.1046 32 18C32 16.8954 31.1046 16 30 16ZM16 26C16 24.8954 16.8954 24 18 24H22C23.1046 24 24 24.8954 24 26C24 27.1046 23.1046 28 22 28H18C16.8954 28 16 27.1046 16 26ZM30 24C28.8954 24 28 24.8954 28 26C28 27.1046 28.8954 28 30 28C31.1046 28 32 27.1046 32 26C32 24.8954 31.1046 24 30 24Z",
    fill: "#6B92FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8C6 6.89543 6.89543 6 8 6H40C41.1046 6 42 6.89543 42 8C42 9.10457 41.1046 10 40 10H8C6.89543 10 6 9.10457 6 8Z",
    fill: "#6B92FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicesvg);
export default __webpack_public_path__ + "static/media/invoicesvg.1b0b6d99.svg";
export { ForwardRef as ReactComponent };